/**
 * Normalize an email address for storage, lookup and display.
 *
 * Emails are always stored lower-cased server-side (see
 * `server/api/src/utils/email.ts`); normalizing on the client too keeps what
 * the user sees — invite lists, the verify-signup screen, OTP round-trips —
 * consistent with what actually gets persisted.
 */
export const normalizeEmail = (email: string): string => email.trim().toLowerCase();

/**
 * Email domains belonging to the people who build and operate the platform.
 * Matched on the domain part only: a plain `endsWith` would also accept
 * `attacker@notactegon.com`.
 */
const INTERNAL_DOMAINS = ['actegon.com', 'skygis.cloud'];

/**
 * True for a member of staff — the audience for the data centre's operational
 * affordances (reset batch, CloudWatch log link, job parameters panel). These
 * are debugging tools, not a product feature: nothing here is a substitute for
 * a server-side authorization check.
 */
export const isInternalUser = (email?: string | null): boolean => {
  if (!email) return false;
  const domain = normalizeEmail(email).split('@')[1];
  return !!domain && INTERNAL_DOMAINS.includes(domain);
};
